import { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router';
import { RoutesSettings } from 'config/index';
import { useVehiclesState, useUpdateVehiclesState } from 'state/vehicles';
import { useMutation } from 'react-query';
import { api } from 'api/api';
import { onError } from 'global/utils/response/error-handler';
import { GetVehiclesRequest } from 'api/vehicles';
import { useAuthState } from 'state/auth';

export const UseMyVehicles = () => {
  const navigate = useNavigate();
  const update = useUpdateVehiclesState();
  const state = useVehiclesState();
  const userState = useAuthState();

  const { isLoading, mutate } = useMutation(
    async (request: GetVehiclesRequest) => api.vehicles.getMyVehicles(request),
    {
      onError,
      onSuccess: response => {
        const { success, ...data } = response.data;
        update.updateState({ ...data });
      },
    },
  );

  const goToCheckPoint = useCallback((id: string) => {
    navigate(RoutesSettings.vehicularCheckPoint.replace(':id', id));
  }, []);

  const goToVehicularDocuments = useCallback((id: string) => {
    navigate(RoutesSettings.vehicleDocuments.replace(':id', id));
  }, []);

  const onChangeFilterBy = useCallback((filterBy: string) => {
    update.updateState({ filterBy });
  }, []);

  useEffect(() => {
    mutate({ filterBy: state.filterBy, from: state.from, rut: userState?.user?.rut || '' });
  }, [state.filterBy]);

  useEffect(
    () => () => {
      update.reset();
    },
    [],
  );

  return {
    ...state,
    goToCheckPoint,
    goToVehicularDocuments,
    isLoading,
    onChangeFilterBy,
    vehicles: state?.vehicles || [],
  };
};
